import { render, staticRenderFns } from "./DhrMasterDetail.vue?vue&type=template&id=7fa2e5bc&scoped=true&"
import script from "./DhrMasterDetail.vue?vue&type=script&lang=js&"
export * from "./DhrMasterDetail.vue?vue&type=script&lang=js&"
import style0 from "./DhrMasterDetail.vue?vue&type=style&index=0&id=7fa2e5bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa2e5bc",
  null
  
)

export default component.exports